import { useTheme } from "@emotion/react";
import styled from "@emotion/styled";
import {
    DialogActions,
    Fab,
    ListItemIcon,
    ListItemText,
    MenuItem,
    SxProps,
} from "@mui/material";
import { themeSettings } from "../../../../configuration/themeSettings";

export const StyledAddBasketButton = styled(Fab, {
    label: "AppBasketMenu-addBasketBtn",
})(({ theme: Theme }) => ({
    backgroundColor: themeSettings.main.palette.primary.main,
    position: "fixed",
    marginLeft: 295,
    marginTop: "-49px",
    width: 34,
    height: 34,
    minHeight: 34,
    minWidth: 34,

}));


export const StyledDialogActions = styled(DialogActions, {
    label: "StyledDialogActions",
})(({ theme: Theme }) => ({
    paddingLeft: 13,
    paddingRight: 13,
    paddingBottom: 7,

}));



